<template>
      <body class="overflow-hidden">
        <div class="mx-4 md:mx-12 py-3 lg:py-8 md:py-12 grid place-content-center px-4 md:px-0">
            <div class="lg:flex justify-start lg:gap-28">
                <div class="">
                    <h1 class="font-bold text-3x1 lg:text-5xl text-white text-left">Total projects = 1756+</h1>
                    <p class="pt-3 lg:pt-8 md:pt-4 text-indigo-300 text-left">As a trusted construction and fabrication company, we have managed to work efficiently on a myriad number of projects.</p>
                    
                    
                </div>
                <div class="pt-8 lg:pt-0">
                    <img src="@/images/projects.png" alt="man in black suit holding brown paper" class="hidden lg:block" />
                    <img src="" alt="man in black suit holding brown paper" class="hidden sm:block lg:hidden" />
                    <img src="@/images/projects.png" alt="man in black suit holding brown paper" class="sm:hidden" />
                </div>
            </div>
        </div>
    </body>
</template>

<script>
export default {

}
</script>

<style>

</style>